import React, { useEffect } from 'react';

import Section from './Section';
import Features from './Features';
import Business from './Business';
import MindPower from './MindPower';
import Cta from './Cta';
import ContactUs from './ContactUs';
import NavBar from './NavBar';
import Footer2 from './../Pages/PageFooterLayouts/Footer2'; ///Pages/PageFooterLayouts/Footer2";

const ITSolutionTwo = () => {
  useEffect(() => {
    if(document.getElementById('topnav'))
      document.getElementById('topnav').classList.add('nav-sticky');

    if(document.body)
      document.body.classList = '';
  });

  return (
    <React.Fragment>
      <NavBar />
      <div id="home">
        <Section />
      </div>
      <section className="section bg-light" id="services">
        <Features />
      </section>
      <section className="section" id="features">
        <Business />
      </section>
      <section className="section pt-0" id="team">
        <MindPower />
      </section>
      <Cta />
      <ContactUs />
      <Footer2 />
    </React.Fragment>
  );
};
export default ITSolutionTwo;
